import { useEffect, useCallback } from 'react';
import { X } from 'lucide-react';

const IFRAME_URL = 'https://live.srba.ro/siteIframe/index.php?partnersId=5&env=1';

export interface CalculatorModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export function CalculatorModal({ isOpen, onClose }: CalculatorModalProps) {
    const handleMessage = useCallback((e: MessageEvent) => {
        if (typeof e.data === 'object' && e.data?.source?.includes('react-devtools')) {
            return;
        }

        const iframe = document.getElementById('remoteIframe') as HTMLIFrameElement;
        if (Array.isArray(e.data)) {
            const [eventName, data] = e.data;
            if (eventName === 'setHeight' && iframe) {
                iframe.style.height = `${data}px`;
            }
        }
    }, []);

    const handleEscape = useCallback(
        (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
        },
        [onClose]
    );

    useEffect(() => {
        if (isOpen) {
            window.addEventListener('message', handleMessage);
            window.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            window.removeEventListener('message', handleMessage);
            window.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, handleMessage, handleEscape]);

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-50 overflow-auto bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 animate-fadeIn"
            onClick={handleOverlayClick}
            role="dialog"
            aria-modal="true"
            aria-labelledby="calculator-title"
        >
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden animate-slideUp">
                {/* Header */}
                <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-main-color">
                    <h2 id="calculator-title" className="text-xl font-font-s font-bold text-white">
                        Calculator asigurare
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-white/80 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10"
                        aria-label="Inchide"
                    >
                        <X className="w-6 h-6" />
                    </button>
                </div>

                {/* Iframe Content */}
                <div className="overflow-auto" style={{ maxHeight: 'calc(90vh - 70px)' }}>
                    <iframe
                        id="remoteIframe"
                        className="w-full"
                        scrolling="yes"
                        style={{
                            overflow: 'hidden',
                            border: 'none',
                            minHeight: '500px',
                            maxHeight: 'calc(90vh - 70px)',
                        }}
                        src={IFRAME_URL}
                        title="Insurance Calculator"
                    />
                </div>
            </div>
        </div>
    );
}
